import type { Image, LinkType } from 'types'
import FeaturedContentHeader from '../FeaturedContentHeader'
import FeaturedImageContent from './ImageContent'
import style from './style.scss'
import FeaturedVideoContent from './VideoContent'

interface BaseProps {
  headlineText: string
  commentLabelText: string
  commentsCount?: number
  commentsUrl?: string
  onLoaded?: () => void
}

interface VideoContentProps extends BaseProps {
  type: 'video'
  videoContent: {
    youtubeVideoId: string
    captionText?: string
  }
}

interface ImageContentProps extends BaseProps {
  type: 'image'
  imageContent: {
    button?: LinkType
    captionText?: string
    image: Image
    isModal?: boolean
    link?: LinkType
  }
}

type Props = VideoContentProps | ImageContentProps

function FeaturedContent({
  headlineText,
  commentLabelText,
  commentsCount,
  commentsUrl,
  ...props
}: Props) {
  switch (props.type) {
    case 'video': {
      const { videoContent } = props
      const { youtubeVideoId, captionText } = videoContent
      return (
        <>
          <FeaturedContentHeader
            className={style.header}
            headlineText={headlineText}
            commentLabelText={commentLabelText}
            commentsCount={commentsCount}
            commentsUrl={commentsUrl}
          />
          <FeaturedVideoContent
            youtubeVideoId={youtubeVideoId}
            captionText={captionText}
          />
        </>
      )
    }
    case 'image': {
      const { imageContent, onLoaded } = props
      const { image, button, link, isModal, captionText } = imageContent
      return (
        <>
          <FeaturedContentHeader
            className={style.header}
            headlineText={headlineText}
            commentLabelText={commentLabelText}
            commentsCount={commentsCount}
            commentsUrl={commentsUrl}
          />
          <FeaturedImageContent
            image={image}
            button={button}
            link={link}
            isModal={isModal}
            captionText={captionText}
            onLoaded={onLoaded}
            headlineText={headlineText}
          />
        </>
      )
    }
  }

  return null
}

export default FeaturedContent
